<template>
  <div class="major-service-block">
    <h1>
      <img src="@/assets/imgs/icon46.png"/>
      <span>服务种类</span>
    </h1>

    <el-row :gutter="20">
      <el-col :span="8">
        <img src="@/assets/imgs/icon51.png"/>
      </el-col>
      <el-col :span="16">
        <div class="info">
          <h2>英文论文润色</h2>
          <p>
            文雅信达团队专注于提供高质量的论文编辑服务，我们的客户群来自国内的博士生、研究人员、科学工作者和工程技术人员。对于非英语母语的研究人员发表国际期刊论文中面临的困难，我们联合了国际上顶尖科学家。他们不仅仅是以英语为母语，而且具有丰富的论文撰与发表经验。我们的平台，不仅仅提供了基础的论文润色修改服务，而且是一个与国际专家进行学术交流的起点。论文作者可以听到专家对论文的修改意见以及论文提高方面的点评，在提高论文语言质量的同时，能够深入体会到论文写作的技巧。通过论文编辑，成为国际合作的新起点。
          </p>
          <el-button @click="toSubmitThesis"  type="primary">立即提交</el-button>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="16">
        <div class="info">
          <h2>中文翻译润色</h2>
          <p>
我们提供“中-英 ” 论文翻译服务，我们的翻译员来自国内高等学校、研究机构，均是具有多年科研工作经验的一线研究人员。他们本身就是学术论文发表者，因此，他们能够理解您的论文思想，将您的论文从中文翻译成英文。翻译后的论文，再经过润色服务以后，即可以达到期刊对论文发表语言的要求。 中文翻译与润色服务大大加快了科研工作者的论文发表周期，将科研工作者的工作重心集中在解决科研问题上，让语言不再成为论文发表的障碍。
          </p>
          <el-button @click="toSubmitThesis"  type="primary">立即提交</el-button>
        </div>
      </el-col>
      <el-col :span="8">
        <img src="@/assets/imgs/icon50.png"/>
      </el-col>
    </el-row>

<el-row :gutter="20">
      <el-col :span="8">
        <img src="@/assets/imgs/icon51.png"/>
      </el-col>
      <el-col :span="16">
        <div class="info">
          <h2>留学申请文书润色/翻译</h2>
          <p>
为广大申请欧美初中、高中、大学本硕博及出国访问的师生，提供提供多种英文申请文书的翻译与润色服务。提供该服务的人员均已通过自身努力实现了留学梦想，对留学申请的完整流程了熟于心，而且具备优秀的英文表达能力。更重要的是，我们平台通过智能匹配，可在很大概率上为顾客找到您目标学校里的兼职服务人员，让您知己知彼，大大增加申请的成功率。该C2C服务模式在留学申请行业尚属先例，相比于传统留学服务具有成功率高、价格优惠的特点。
          </p>
          <el-button @click="toSubmitThesis"  type="primary">立即提交</el-button>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="16">
        <div class="info">
          <h2>文书/稿件排版</h2>
          <p>
由熟练掌握Office软件的硕士研究生以上学历人员提供诸如专著、项目申请书、标书、期刊论文等材料的文字检校与排版服务，为您省下宝贵的创作与科研时间，更能保证材料的专业性。
          </p>
          <el-button @click="toSubmitThesis"  type="primary">立即提交</el-button>
        </div>
      </el-col>
      <el-col :span="8">
        <img src="@/assets/imgs/icon50.png"/>
      </el-col>
    </el-row>

    <h1>
      <img src="@/assets/imgs/icon46.png"/>
      <span>专业领域</span>
    </h1>

    <el-row :gutter="20">
      <el-col :span="8">
        <img src="@/assets/imgs/icon51.png"/>
      </el-col>
      <el-col :span="16">
        <div class="info">
          <h2>地球科学 Earth Science</h2>
          <p>
Remote Sensing, Geography, Ecology, Agriculture, Forestry, Water resources, Fire, Phenology, Data Fusion, Ecosystem Modeling, Biogeochemical Modeling, Land use and Land cover, Climate Change, Energy, Urban, GIS…
          </p>
          <el-button @click="toSubmitThesis"  type="primary">立即提交</el-button>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="16">
        <div class="info">
          <h2>生物、医药 Biology and Medicine</h2>
          <p>
Biochemistry, Biological techniques, Biophysics, Biotechnology, Cancer, Cell biology, Chemical biology, Computational biology and bioinformatics, Developmental biology, Drug discovery, Ecology, Evolution, Genetics, Immunology, Microbiology, Molecular biology, Neuroscience, Physiology, Plant sciences, Psychology, Stem cells, Structural biology, Systems biology, Zoology …
          </p>
          <el-button @click="toSubmitThesis"  type="primary">立即提交</el-button>
        </div>
      </el-col>
      <el-col :span="8">
        <img src="@/assets/imgs/icon50.png"/>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="8">
        <img src="@/assets/imgs/icon51.png"/>
      </el-col>
      <el-col :span="16">
        <div class="info">
          <h2>材料科学 Material Science</h2>
          <p>
Material Science, Nanomaterials, Biomaterials, Electronic, optical, and magnetic materials, Computational materials science and engineering, Ceramics and glasses, Composites, Polymers, Metal and alloys, Energy Materials, Material physics, Material chemistry…
          </p>
          <el-button @click="toSubmitThesis"  type="primary">立即提交</el-button>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="16">
        <div class="info">
          <h2>计算机科学 Computer Science</h2>
          <p>
Data structures and algorithms, Information and coding theory, Programming language theory, Computer security and cryptography, Computer graphics and visualization, Human-computer interaction, Scientific computing, Artificial intelligence, Deep learning …
          </p>
          <el-button @click="toSubmitThesis"  type="primary">立即提交</el-button>
        </div>
      </el-col>
      <el-col :span="8">
        <img src="@/assets/imgs/icon50.png"/>
      </el-col>
    </el-row>

  </div>
</template>

<script>
/**
 * @description 论文润色-专业与服务
 */
// import * as api from '@/api/login'
export default {
  name: 'MajorService',
  data() {
    return {
      
    }
  },
  created() {},
  methods: {
    /**
     * @description 跳转到提交论文页面
     */
    toSubmitThesis() {
        this.$router.push({
          path: '/requirement-submission?activeName=submit_thesis'
        })
    }
    //     /**
    //  * @description 获取角色列表
    //  */
    // getListByPage() {
    //   const _this = this
    //   _this.tableLoading = true
    //   const _param = {
    //     page: _this.pageparm.page,
    //     size: _this.pageparm.size,
    //     roleName: _this.pageparm.roleName,
    //     orgid: _this.pageparm.orgid
    //   }
    //   api.listByPage(_param)
    //     .then(res => {
    //       const data = res.data
    //       _this.tableLoading = false
    //       _this.listData = data.result
    //       _this.pageparm.total = data.pageTotalCount
    //     })
    //     // .catch(err => {
    //     // })
    // },
  },
}
</script>
<style lang="scss" scoped>
.major-service-block {
  
  h1 {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fddd68;
    margin: 0;

    img {
      height: 38px;
      margin: 0 10px 0 0;
    }

  }

  .el-row {
    margin: 50px 0 30px 0;

    .el-col {

      img {
        display: block;
        margin: 20px auto 0 auto;
        height: 200px;
      }

    }

    .el-col:last-of-type .info .el-button { 
      float: right;
    }

  }

  .info {
    h2 {
      margin: 0 0 15px 0;
    }

    p {
      font-size: 16px;
      color: #616161;
      margin: 0 0 15px 0;
      line-height: 1.5;
    }

  }

}
</style>